<div [ngClass]="variant === 'header' ? '' : 'mb-6 px-4 md:px-0'">
  <div class="flex gap-3" [ngClass]="variant === 'header' ? 'justify-end' : 'mb-4'">
    <div *ngIf="cyclePhase.state" class="bg-white/50 backdrop-blur-sm rounded-full px-4 py-2 border border-black">
      <span class="text-sm font-medium text-gray-900">
        <ng-container [ngSwitch]="cyclePhase.state">
          <ng-container *ngSwitchCase="'Pregnancy'">
            <span class="font-bold">Pregnancy:</span>
            <span class="ml-1">{{ cyclePhase.trimester }}</span>
          </ng-container>

          <ng-container *ngSwitchCase="'Postpartum'">
            <span class="font-bold">Postpartum</span>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <span class="font-bold">Cycle Phase:</span>
            <span class="ml-1">{{ cyclePhase.state }}</span>
          </ng-container>
        </ng-container>
      </span>
    </div>

    <div *ngIf="cyclePhase.day != null" class="bg-white/50 backdrop-blur-sm rounded-full px-4 py-2 border border-black">
      <span class="text-sm text-gray-900"
            [ngClass]="(cyclePhase.state === 'Pregnancy' || cyclePhase.state === 'Postpartum') ? 'font-bold' : 'font-bold'">
        {{ (cyclePhase.state === 'Pregnancy' || cyclePhase.state === 'Postpartum') ? '' : 'Day' }}
      </span>
      <span class="text-sm text-gray-900"
            [ngClass]="(cyclePhase.state === 'Pregnancy' || cyclePhase.state === 'Postpartum') ? 'font-bold' : 'font-medium'">
        {{ cyclePhase.day }}
      </span>
    </div>
  </div>
</div>
